import type { TFunction } from 'i18next';

import type { ChatType } from '../types';

/** The title of a chat as the reader sees it: the saved chat has none on the wire (it is named in the reader's language). */
export const chatTitle = (chat: { type: ChatType; title: string }, t: TFunction<'messenger'>): string =>
  chat.type === 'saved' ? t('saved.title') : chat.title;
